import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const adminToken = localStorage.getItem("sc_admin_token");
    const staffToken = localStorage.getItem("sc_staff_token");
    const memberToken = localStorage.getItem("sc_member_token");
    const url = config.url || "";

    const isMember = url.startsWith("/member/");
    const isStaffOrAdmin =
        url.startsWith("/staff") ||
        url === "/admin/scan" ||
        url === "/admin/occupancy" ||
        /^\/admin\/applications\/[^/]+\/check-(in|out)$/.test(url);
    const isAdmin = url.startsWith("/admin") || url === "/auth/me";

    if (isMember) {
        if (memberToken) config.headers.Authorization = `Bearer ${memberToken}`;
    } else if (isStaffOrAdmin) {
        const t = adminToken || staffToken;
        if (t) config.headers.Authorization = `Bearer ${t}`;
    } else if (isAdmin) {
        if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
});

export const photoUrl = (photoId) => {
    if (!photoId) return "";
    const t = localStorage.getItem("sc_admin_token")
        || localStorage.getItem("sc_staff_token")
        || localStorage.getItem("sc_member_token");
    return t ? `${API}/photos/${photoId}?t=${encodeURIComponent(t)}` : `${API}/photos/${photoId}`;
};
export const qrUrl = () => `${API}/member/qr`;
